import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { db } from "../Components/Firebase";
import { collection, addDoc } from "firebase/firestore";
import SapakimHead from "./SapakimHead";
import '../Styles/Sapakim/SAddNewCustomer.css';

function SAddNewCustomer() {
  const nav = useNavigate();
  const { UID } = useParams();

  const [formData, setFormData] = useState({
    Name: "",
    Email: "",
    ExtraPhone: "",
    IdNumber: "",
    PhoneNumber: "",
    Location: "",
    PostalCode: ""
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await addDoc(collection(db, "Customers"), {
        ...formData,
        SapakId: UID
      });
      nav(-1);
    } catch (err) {
      console.error("שגיאה בהוספת לקוח:", err);
      setError("אירעה שגיאה. נסה שוב.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <SapakimHead />
      <div className="customer-form-container" dir="rtl">
        <h2>הוסף לקוח חדש</h2>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleSubmit} className="customer-form">
          <input name="Name" placeholder="שם" value={formData.Name} onChange={handleChange} required />
          <input name="Email" placeholder="אימייל" type="email" value={formData.Email} onChange={handleChange} />
          <input name="PhoneNumber" placeholder="טלפון" value={formData.PhoneNumber} onChange={handleChange} />
          <input name="ExtraPhone" placeholder="טלפון נוסף" value={formData.ExtraPhone} onChange={handleChange} />
          <input name="IdNumber" placeholder="תעודת זהות" value={formData.IdNumber} onChange={handleChange} />
          <input name="Location" placeholder="כתובת" value={formData.Location} onChange={handleChange} />
          <input name="PostalCode" placeholder="מיקוד" value={formData.PostalCode} onChange={handleChange} />
          <button type="submit" disabled={loading}>
            {loading ? "שומר..." : "שמור לקוח"}
          </button>
        </form>
      </div>
    </React.Fragment>
  );
}

export default SAddNewCustomer;
